import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import { Assessment } from "@material-ui/icons";
import LoadingDefault from "../LoadingDefault";
import { b64toBlob } from "../../helper/convertBase64toBlob";
import api from "../../config/api";
import ContentNotLoaded from "../ContentNotLoaded";
import InputDateRange from "../InputDateRange";

const styles = () => ({
  loadingDivRel: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "12px",
  },
  IconeFabRelatorio: {
    backgroundColor: "#fff",
    marginRight: "10px",
    color: "#0066b2",
    transition: "all .2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  divPeriodo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "15px",
  },
});

const PrintVariacaoMensalRel = (props) => {
  const [loadingRel, setLoadingRel] = React.useState(false);
  const [snackBarMessage, setSnackBarMessage] = React.useState("");
  const [parametros, setParametros] = React.useState({});
  const [open, setOpen] = React.useState(false);

  function handleVariacaoMensalRel() {
    setLoadingRel(true);
    setSnackBarMessage("");

    let params = {
      periodoInicial: parametros.dataInicio,
      periodoFinal: parametros.dataFim,
    };

    const diff = Math.abs(params.periodoInicial - params.periodoFinal); // Subtrai uma data pela outra
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24)); // Divide o total pelo total de milisegundos correspondentes a 1 dia. (1000 milisegundos = 1 segundo).

    if (days <= 365) {
      try {
        api
          .get("Gestao/ObterRelatorioVariacaoMensalDam", { params })
          .then((DAMResponse) => {
            let pdf = "";
            if (DAMResponse.data !== null && DAMResponse.data !== undefined) {
              pdf = DAMResponse.data;

              setLoadingRel(false);

              if (
                pdf === "O período informado não pode ser superior a 12 meses."
              ) {
                setSnackBarMessage(pdf);
              } else {
                setOpen(false);
                var file = b64toBlob(pdf, "application/pdf");
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL, "EPrescription");
              }
            } else {
              setLoadingRel(false);
              setSnackBarMessage("");
            }
          });
      } catch (error) {
        setLoadingRel(false);
        setSnackBarMessage(error?.Message);
      }
    } else {
      setLoadingRel(false);
      setSnackBarMessage("Selecione um intervalo de no maximo 12 meses");
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function getDataEmissao(dateMin, dateMax) {
    setParametros({
      dataInicio: dateMin,
      dataFim: dateMax,
    });
  }

  return (
    <>
      <Fab
        className={props.classes.IconeFabRelatorio}
        onClick={handleClickOpen}
      >
        <Tooltip placement="top" title="Relátorios de Variação Mensal">
          {loadingRel ? (
            <div className={props.classes.loadingDivRel}>
              <LoadingDefault typeLoading={"debits"} />
            </div>
          ) : (
            <Assessment />
          )}
        </Tooltip>
      </Fab>
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth="lg"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle>Relátorios de Variação Mensal</DialogTitle>
        <DialogContent>
          <Box padding={2}>
            <div id="divPeriodo" className={props.classes.divPeriodo}>
              <InputDateRange
                getInputDateRange={getDataEmissao}
                inputValueMin={parametros.dataInicio}
                inputValueMax={parametros.dataFim}
                title="SELECIONE O PERIODO DE CONSULTA"
              />
            </div>
            {snackBarMessage && <ContentNotLoaded message={snackBarMessage} />}
            <br />
            <Grid container justifyContent="flex-end" spacing={3}>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button
                onClick={() => handleVariacaoMensalRel()}
                color="primary"
                autoFocus
              >
                Confirmar
              </Button>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default withStyles(styles, { withTheme: true })(PrintVariacaoMensalRel);
